import { useSelector } from "react-redux";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { DEFAULT_CURRENCY } from "@/config";

export const useCurrency = (): string => {
  return useSelector(UserSelectors.getCurrency) || DEFAULT_CURRENCY;
};
